import { component } from 'riot'

class ModalService {
    constructor() {
        this.instance = null;
        this.container = document.createElement('div')
        document.body.appendChild(this.container)
    }

    async initialize() {
        if (!this.instance) {
            const { default: GlobalModal } = await import('../components/global-modal.tag');
            this.instance = component(GlobalModal)(this.container)
        }
    }

    async show(message, title = 'Notice') {
        await this.initialize();
        this.instance.show(message, title)
    }

    async close() {
        await this.initialize();
        this.instance.close()
    }
}

let instance = null

export function getModalService() {
    if (!instance) {
        instance = new ModalService()
    }
    return instance
}

// Lazy getter for backward compatibility with method binding
export const modalService = new Proxy({}, {
    get(target, prop) {
        const instance = getModalService()
        const value = instance[prop]
        // Bind methods to preserve 'this' context when called through Proxy
        if (typeof value === 'function') {
            return value.bind(instance)
        }
        return value
    }
})
